import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { use } from '../utils';
import { inherit } from '../utils/functional'; // Types

var _use = use('cell-group'),
    sfc = _use[0],
    bem = _use[1];

var CellGroup = function CellGroup(h, props, slots, ctx) {
  return h("div", _mergeJSXProps([{
    "class": [bem(), {
      'van-hairline--top-bottom': props.border
    }]
  }, inherit(ctx, true)]), [slots.default && slots.default()]);
};

CellGroup.props = {
  border: {
    type: Boolean,
    default: true
  }
};
export default sfc(CellGroup);


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/cell-group/index.js
// module id = 46
// module chunks = 0 1 3